import { partialMessage } from './constants';
export const checkIgnore = (_, __, item) => {
    const payload = item;
    const frames = payload.body.trace.frames;
    const message = payload.body.trace?.exception.message;
    const hasSomePartialMessage = checkPartialMessage(message);
    const hasSomeExtensionFrame = frames.some(checkExtensionFrame);
    return hasSomeExtensionFrame || hasSomePartialMessage;
};
const checkPartialMessage = (message) => {
    return partialMessage.some(partial => message.includes(partial));
};
const checkExtensionFrame = (frame) => {
    if (frame.filename) {
        return frame.filename.startsWith('chrome-extension');
    }
    return false;
};
